<template>
    <validation-provider
        :name="formatLabel(label)"
        :vid="vid"
        :rules="rules"
        v-slot="{errors, valid}"
    >
        <b-form-group
            :label="label + ':'"
            :description="description"
            :label-cols-xl="labelColsXl"
            :label-cols-lg="labelColsLg"
            :label-cols-md="labelColsMd"
            :label-cols-Sm="labelColsSm"
            :label-cols="labelCols"
        >
            <b-form-radio-group
                v-if="type === 'radio'"
                v-model="input"
                :options="options"
                :disabled="disabled"
                :buttons="!disabled"
                button-variant="outline-primary"
            />
            <b-form-checkbox
                v-else-if="type === 'checkbox'"
                v-model="input"
                :disabled="disabled"
                value="1"
                rules = "required"
                unchecked-value="0">
                {{ input == 1 ? "да" : "" }}
            </b-form-checkbox>
            <b-form-checkbox
                    v-else-if="type === 'checkbox-reg'"
                    v-model="input"
                    :disabled="disabled"
                    value="1"
                    rules = "required"
                    unchecked-value="0">
                Согласен с условиями <a href="/page/reglament" target="_blank">Регламента</a>
            </b-form-checkbox>
            <input-date-picker
                v-else-if="type === 'date'"
                v-model="input"
                :disabled="disabled"
            />
            <b-form-textarea
                v-else-if="type === 'textarea'"
                v-model="input"
                :disabled="disabled"
            />
            <vue-json-editor
                v-else-if="type === 'json'"
                v-model="input"
                :disabled="disabled"
                mode="code"
                lang="ru"
            />
            <b-form-input
                v-else
                :disabled="disabled"
                v-model="input"
                :state="showState && !disabled ? valid : undefined"
                :placeholder="placeholder"
                :type="type"
                :name="name"
            />
            <b-form-invalid-feedback :state="getState(valid)">{{ invalidFeedback(errors) }}</b-form-invalid-feedback>
        </b-form-group>
    </validation-provider>
</template>

<script>
import {toFormLowerCase} from '@/helpers/form-helpers'

export default {
    components: {
        InputDatePicker: () => import('@features/Forms/InputDatePicker'),
        vueJsonEditor: () => import('vue-json-editor'),
    },
    name: "ValidationInput",
    model: {
        event: "change",
        prop: "value",
    },
    data: () => ({
        original: '',
    }),
    created() {
        this.original = this.value
    },
    watch: {
        validationErrors() {
            this.original = this.value
        }
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        name: {
            type: String,
        },
        rules: {
            type: String | Object,
            default: "",
        },
        description: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String | Number,
            required: true,
        },
        type: {
            type: String,
            default: "text",
        },
        vid: {
            type: String,
            default: "text",
        },
        placeholder: {
            type: String,
            default: "",
        },
        showState: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Object | Array | String,
        },
        validationErrors: {
            type: Array
        },
        labelColsXl: {
            type: String
        },
        labelColsLg: {
            type: String
        },
        labelColsMd: {
            type: String
        },
        labelColsSm: {
            type: String
        },
        labelCols: {
            type: String
        },
        inputRef: {
            type: String,
        }
    },
    computed: {
        input: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("change", value);
            },
        },
    },
    methods: {
        invalidFeedback(errors) {
            if(this.disabled) return ''
            if(this.original === this.value) {
                if (this.validationErrors) return this.validationErrors[0]
            }
            if(errors) return errors[0]
            return '';
        },
        getState(valid) {
            if(this.disabled) return undefined
            if(this.validationErrors) return false
            return valid
        },
        formatLabel(label) {
            return `"${label}"`
        }
    }
};
</script>
